<header>
    <span>Filter displayed data</span>
    <button type="button" (click)="dialogRef.close()">
        <span></span>
    </button>
</header>
<div class="group">
    <label for="dkName">Filter by Dikshyarthi name</label>
    <input type="text" id="dkName" class="dp-input-control" placeholder="Enter Dikshyarthi name"
    name="dikshyarthi" [(ngModel)]="appliedFilters.dikshyarthiName">
</div>
<div class="group">
    <label for="address">Filter by address</label>
    <input type="text" id="address" class="dp-input-control" placeholder="Enter member address"
    name="address" [(ngModel)]="appliedFilters.address">
</div>
<div class="group">
    <label for="visited">Filter by visited/not-visited</label>
    <mat-form-field class="select-mat-form-field dp-input-control select">
        <mat-select id="visited" placeholder="(Select if visited or not)"
        name="isVisited" [(ngModel)]="appliedFilters.isVisited">
            <mat-option [value]="0">Not visited</mat-option>
            <mat-option [value]="1">Visited</mat-option>
        </mat-select>
    </mat-form-field>
</div>
<button type="button" class="dp-secondary-btn" (click)="applyFilter()">Apply filter</button>